export default "__VITE_ASSET__CNpzIPSy__"